import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

@Injectable({
    providedIn: 'root'
})
export class CustomIconService {
    constructor(private library: FaIconLibrary) {}

    registerCustomIcons() {
        const fullContainerIcon = {
            prefix: 'custom' as any,
            iconName: 'full-container' as any,
            icon: [
                16, // width
                16, // height
                [], // ligatures
                '', // unicode
                'M5.59.24.879 3.014A1.767 1.767 0 0 0 0 4.54v5.01c0 .633.352 1.214.88 1.53l7.753 4.521.002.001c.55.321 1.224.321 1.774 0h.001l4.717-2.753A1.76 1.76 0 0 0 16 11.327V6.292c0-.304-.078-.598-.22-.855l-.004-.005-.01-.019a1.746 1.746 0 0 0-.64-.643L7.359.239a1.75 1.75 0 0 0-1.765 0L5.592.24Zm1.013 1.294 7.17 4.182-4.116 2.388a.27.27 0 0 1-.269 0L2.236 3.956l4.115-2.422a.25.25 0 0 1 .252 0m7.768 10.02-4.1 2.393V9.474c.048-.022.094-.046.138-.072L14.5 7.029v4.298'
            ]
        };

        const emptyContainerIcon = {
            prefix: 'custom' as any,
            iconName: 'empty-container' as any,
            icon: [
                16, // width
                16, // height
                [], // ligatures
                '', // unicode
                'm5.59.24l-4.711 2.774c-.544.316-.878.897-.879 1.526v5.01c0 .633.352 1.214.88 1.53l7.753 4.521l.002.001c.55.321 1.224.321 1.774 0h.001l4.717-2.753A1.76 1.76 0 0 0 16 11.327V6.292c0-.304-.078-.598-.22-.855l-.004-.005l-.01-.019c-.15-.262-.369-.486-.64-.643L7.359.239a1.75 1.75 0 0 0-1.765 0l-.002.001ZM6.603 1.534l7.17 4.182l-4.116 2.388a.27.27 0 0 1-.269 0L2.236 3.956l4.115-2.422a.25.25 0 0 1 .252 0m7.768 10.02l-4.1 2.393V9.474c.048-.022.094-.046.138-.072L14.5 7.029v4.298c0 .095-.05.181-.129.227m-8.6.642l-1.521-.887v-4.45l1.521.882ZM8.635 9.402h-.001q.066.038.136.071v4.472l-1.5-.875V8.61Zm-5.885 1.032l-1.115-.65h-.002a.27.27 0 0 1-.133-.232V5.264l1.25.725Z'
            ]
        };

        const containerYardIcon = {
            prefix: 'custom' as any,
            iconName: 'container-yard' as any,
            icon: [
                16, // width
                16, // height
                [], // ligatures
                '', // unicode
                'M5.333 2H10.667A0.667 0.667 0 0 1 11.333 2.667V5.333A0.667 0.667 0 0 1 10.667 6H5.333A0.667 0.667 0 0 1 4.667 5.333V2.667A0.667 0.667 0 0 1 5.333 2Z M2.667 7.333H13.333A0.667 0.667 0 0 1 14 8V10.667A0.667 0.667 0 0 1 13.333 11.333H2.667A0.667 0.667 0 0 1 2 10.667V8A0.667 0.667 0 0 1 2.667 7.333Z M1.333 12.667H14.667V14H1.333Z'
            ]
        };
        this.library.addIcons(fullContainerIcon as any, emptyContainerIcon as any, containerYardIcon as any);
    }
}
